import React from "react";

const ResponsiveContainer: React.FC = (props) => {
  return <div className="my-8 px-4 sm:p-0">{props.children}</div>;
};

export default ResponsiveContainer;
